// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityPlan {
    'isAccumulator'?: string;
    'isMaximizer'?: string;
    'effectiveDate'?: string;
    'name'?: string;
    'priority'?: string;
    'terminationDate'?: string;
    'type'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityPlan>> = [
        {
            "name":     "isAccumulator",
            "baseName": "isAccumulator",
            "type":     "string"
        },
        {
            "name":     "isMaximizer",
            "baseName": "isMaximizer",
            "type":     "string"
        },
        {
            "name":     "effectiveDate",
            "baseName": "effectiveDate",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "priority",
            "baseName": "priority",
            "type":     "string"
        },
        {
            "name":     "terminationDate",
            "baseName": "terminationDate",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityPlan.attributeTypeMap;
    }
}
